import React, { Component } from 'react';
import { Field, reduxForm } from 'redux-form'
import Isvg from 'react-inlinesvg';

import Text from './fields/text';
import Image from './fields/image';
import Html from './fields/html';
import Select from './fields/select';

import image from '../../assets/svg/image.svg';

import {
    Container,
    Row,
    Col,
} from 'reactstrap';

const required = value => value ? undefined : "Required"
const renderSelectField = ({
    input,
    placeholder,
    label,
    meta: { touched, error },
    children,
    additionalAction,
    scope,
}) => (

        <Select
            placeholder={placeholder}
            label={label}
            errorText={touched && error}
            error={touched && error}
            additionalAction={additionalAction}
            scope={scope}
            {...input}
            children={children}
        />
    )
const renderTextField = ({
    input,
    placeholder,
    label,
    meta: { touched, error },
}) => (

        <Text
            placeholder={placeholder}
            label={label}
            errorText={touched && error}
            error={touched && error}
            {...input}
        />
    )

    const renderImageField = ({
        input,
        placeholder,
        meta: { touched, error },
    }) => (
    
            <Image
                placeholder={placeholder}
                errorText={touched && error}
                error={touched && error}
    
                {...input}
            />
        )
    

const renderHtmlField = ({
    input,
    placeholder,
    meta: { touched, error },
}) => (

        <Html
            placeholder={placeholder}
            errorText={touched && error}
            error={touched && error}

            {...input}
        />
    )



const form = (props) => {
    const { handleSubmit, pristine, reset, submitting } = props;
    console.log(pristine, submitting);

    return (
        <form onSubmit={handleSubmit}>
            <Row>
                <Col lg="12" >
                    <Container fluid className="form-box">
                        <Row>
                            <Col lg="12">
                                <h3 className="title">Title</h3>
                                <h6 className="subtitle">Enter title of blog</h6>

                            </Col>
                            <Col lg="6" className="input-wrap">
                                <Field
                                    name="title"
                                    component={renderTextField}
                                    label={"Title"}
                                    placeholder="Enter title of blog"

                                ></Field>
                            </Col>
                            <Col lg="12"></Col>
                            <Col lg="6" className="input-wrap">
                                <Field
                                    name="category"
                                    component={renderSelectField}
                                    label={"Category"}
                                    placeholder="Choose category"

                                >{
                                    props.blogCategories.map((item, idx) => {
                                        return (
                                            <option value={item.id}>{item.name}</option>
                                        )
                                    })
                                }</Field>
                            </Col>
                            <Col lg="12"></Col>

                            <Col lg="6" className="input-wrap">
                                <Field
                                    name="image"
                                    component={renderImageField}
                                    label={"Image"}
                                    placeholder="Enter title of blog"

                                ></Field>
                            </Col>

                            <Col lg="12">
                                <h3 className="title">Content</h3>
                                <h6 className="subtitle">Enter blog content</h6>

                            </Col>
                            <Field
                                name="content"
                                component={renderHtmlField}
                                placeholder="Enter text"

                            ></Field>


                        </Row>
                    </Container>
                </Col>

                <Col lg="12">
                    <button className="button">Save</button>

                </Col>

            </Row>

        </form>
    )
}

export default reduxForm({
    form: 'form'  // a unique identifier for this form
})(form)
